// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatDateFieldValue = (dateFieldValue: any) => {
  // Transform date from yyyy-mm-dd (formik response) to mm/dd/yyyy (calendar format)
  const formattedStringDate = dateFieldValue.replaceAll("-", "/");
  const currentDateFromFormik = new Date(formattedStringDate);
  if (!currentDateFromFormik) {
    return new Date();
  }
  const day = currentDateFromFormik.getDate();
  const month = currentDateFromFormik.getMonth() + 1;
  const year = currentDateFromFormik.getFullYear();
  return `${month}/${day}/${year}`;
};
